import { render, staticRenderFns } from "./AddSelect.vue?vue&type=template&id=2bc88a8c&scoped=true"
import script from "./AddSelect.vue?vue&type=script&lang=js"
export * from "./AddSelect.vue?vue&type=script&lang=js"
import style0 from "./AddSelect.vue?vue&type=style&index=0&id=2bc88a8c&prod&lang=scss&scoped=true"
import style1 from "./AddSelect.vue?vue&type=style&index=1&id=2bc88a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc88a8c",
  null
  
)

export default component.exports